import React from "react";
import { MenuItems } from "@/utils/MenuItems.constants";
import StaticPage from "@/components/staticPage/StaticPage";
import UserAgreementPage from "@/shared/pages/UserAgreementPage";
import { getServerProps } from "@/components/staticPage/StaticPage.utils";

const UserAgreement = (props) => {
  return <StaticPage {...props} StaticPageComponent={UserAgreementPage} />;
};

export async function getServerSideProps(context) {
  return await getServerProps(context, MenuItems.userAgreement);
}

export default UserAgreement;
